import { api } from './client.js';

export const notificationsApi = {
  list: () => api.get('/api/notifications'),
  markRead: (id) => api.patch(`/api/notifications/${id}`, { read: true }),
  markAllRead: () => api.patch('/api/notifications/all', { read: true }),
};
